import homepageConfig from '../Data/homepage-loan'
import privateConfig from  '../Data/private-loan'
import quickConfig from '../Data/quick-loan'
import businessConfig from '../Data/business-config'

class LoanConfigFactory {
  static getConfig(type) {
    switch (type) {
      case 'homepage' :
        return homepageConfig;
      case 'private' :
        return privateConfig;
      case 'quick' :
        return quickConfig;
      case 'business' :
        return businessConfig;
    }
  }
}

export default LoanConfigFactory



// WEBPACK FOOTER //
// ./scripts/libs/LoanConfigFactory.js